import { z } from 'zod';

export const ManageAccountEmailsFormSchema = z.object({
  BenchUpdates: z.boolean().default(false).nullable(),
  AvailabilityUpdates: z.boolean().default(false).nullable(),
});

export type ManageAccountEmailsForm = z.infer<
  typeof ManageAccountEmailsFormSchema
>;
